
import styled from "styled-components";

export const Wrapper = styled.div`
.ant-picker-input input{font-size:14px}
`;
